import PagedElements from '@/models/paged/pagedelements';
import ItemPrinterLinkListViewModel from '@/models/view/itemprinterlinklistviewmodel';

export default class PagedItemPrinterLinks extends PagedElements<ItemPrinterLinkListViewModel> {
    constructor(init?: Partial<PagedItemPrinterLinks>) {
        super(init);
    }
}
